import { format, startOfMonth } from "date-fns";

// Datas no formato yyyy-MM-dd que as rotas de cobrança esperam (vencimento e
// expiração do boleto, data de cálculo da quitação, período do reprocessamento).
// Sempre a partir da data LOCAL — não usar toISOString: à noite (UTC-3) ele
// pula pro dia seguinte.
export const toYYYYMMDD = (date: Date | null): string | undefined =>
  date ? format(date, "yyyy-MM-dd") : undefined;

export const hojeYYYYMMDD = (): string => format(new Date(), "yyyy-MM-dd");

export const inicioDoMesYYYYMMDD = (): string => format(startOfMonth(new Date()), "yyyy-MM-dd");
